import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  IconButton,
  MenuItem,
  Snackbar,
  Modal,
} from "@mui/material";
import {
  ActionMsg,
  Breadcrumb,
  Cancel,
  CTSinput,
  CTSinputNo,
  HandleCloseSnackbar,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import styles from "../../../styles.module.css";
import { Balance } from "@mui/icons-material";
import {
  addProductionPlanning,
  editDeleteProductionPlanning,
  getCylinderList,
  getDeliveryChallanList,
  getProductionPlanningList,
  getScheduleEntryList,
} from "../../../actions/actions";
import ViewScheduleList from "../viewSchedule/ViewScheduleList"; // Make sure to import your ViewScheduleList component
import CloseIcon from "@mui/icons-material/Close"; // Import CloseIcon
import ViewCylinderList from "../viewSchedule/ViewCylinderList";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const ProductionPlanningAdd = () => {
  // const classes = useStyles();
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;
  const [selectedRecords, setSelectedRecords] = useState([]); // Add this line
  console.log(selectedRecords, "selectedrecord");
  const handleSelectRecords = (records) => {
    // setSelectedRecords(records);
    setPpDetails(records);
    //handleCloseModal();
    handleScheduleCloseModal(); // Close the modal after selection has
    handleCylinderCloseModal(); // Close the modal after selection has
  };
  // const login_details = sessionStorage.getItem('loginUser');
  // const userD = JSON.parse(login_details);
  // const userInfo = userD.userInfo;
  const { handleSubmit } = useForm();
  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;
  const editid = editData ? editData.pp_id : null;
  console.log("edit:", editData);
  let navigate = useNavigate();
  const [isSet, setIsSet] = useState(false);
  // const [schedule_date, setSchedule_date] = useState(new Date());
  const [data, setData] = useState({
    pp_no: editData ? editData.pp_no : "",
    prepared_by: editData ? editData.prepared_by : "",
    approved_by: editData ? editData.approved_by : "",
    // schedule_date: editData ? editData.schedule_date : new Date(),
    pp_date: editData
      ? new Date(editData.pp_date).toISOString().split("T")[0]
      : new Date().toISOString().split("T")[0],
  });
/////////////////////////

  const { schedule_entry } = useSelector((state) => state.schedule_entry);
  const { production_planning } = useSelector((state) => state.production_planning);
  const { delivery_challan } = useSelector ((state) => state.delivery_challan)
  const { cylinder } = useSelector ((state) => state.cylinder)
 
  useEffect(() => {
    dispatch(getScheduleEntryList({ page: 0, size: 999, searchKey: "" }));
    dispatch(getProductionPlanningList({ page: 0, size: 999, searchKey: "" }));
    dispatch(getDeliveryChallanList({ page: 0, size: 999, searchKey: "" }));
    dispatch(getCylinderList({ page: 0, size: 999, searchKey: ""  }))
  
  }, [dispatch]);


  const [pp_details, setPpDetails] = useState([]); // Initialize as an empty array


  // useEffect(() => {
  //   if (schedule_entry) {
  //     const formattedDetails = schedule_entry.map((entry) => ({
  //       sr_no: entry.schedule_id || "",
  //       customer_name: entry.customer_name || "",
  //       schedule_no: entry.schedule_no || "",
  //       schedule_details: JSON.parse(entry.schedule_details || "[]"), // Parse child data
  //     }));
  //     setPpDetails(formattedDetails);
  //   }
  // }, [schedule_entry]);

////////////////////////////////////////
// useEffect(() => {
//   if (schedule_entry && delivery_challan) {
//     const updatedPpDetails = schedule_entry.map((entry) => {
//       const scheduleDetails = JSON.parse(entry.schedule_details || "[]");

//       const updatedScheduleDetails = scheduleDetails.map((detail) => {
//         // Find matching delivery challan entries
//         const matchingChallans = delivery_challan.filter((challan) => {
//           const challanDetails = JSON.parse(challan.dc_details || "[]");
//           return (
//             challan.customer_name === entry.customer_name &&
//             challan.schedule_no === entry.schedule_no &&
//             challanDetails.some((dcDetail) => dcDetail.product === detail.product)
//           );
//         });

//         // Sum up the quantities for the matching entries
//         const totalQty = matchingChallans.reduce((sum, challan) => {
//           const challanDetails = JSON.parse(challan.dc_details || "[]");
//           const productQty = challanDetails.reduce((productSum, dcDetail) => {
//             if (dcDetail.product === detail.product) {
//               return productSum + parseFloat(dcDetail.qty || 0);
//             }
//             return productSum;
//           }, 0);
//           return sum + productQty;
//         }, 0);

//         // Calculate bal_qty
//         const balQty = parseFloat(detail.soqty || 0) - totalQty;

//         return {
//           ...detail,
//           delivery_qty: totalQty, // Update delivery_qty with the calculated total
//           bal_qty: balQty, // Calculate and update bal_qty
//         };
//       });

//       return {
//         ...entry,
//         schedule_details: updatedScheduleDetails,
//       };
//     });

//     setPpDetails(updatedPpDetails);
//   }
// }, [schedule_entry, delivery_challan]);

/////////////////////////////
useEffect(() => {
  if (schedule_entry && delivery_challan && cylinder) {
    const updatedPpDetails = schedule_entry.map((entry) => {
      const scheduleDetails = JSON.parse(entry.schedule_details || "[]");

      const updatedScheduleDetails = scheduleDetails.map((detail) => {
        // Find matching delivery challan entries
        const matchingChallans = delivery_challan.filter((challan) => {
          const challanDetails = JSON.parse(challan.dc_details || "[]");
          return (
            challan.customer_name === entry.customer_name &&
            challan.schedule_no === entry.schedule_no &&
            challanDetails.some((dcDetail) => dcDetail.product === detail.product)
          );
        });

        // Sum up the quantities for the matching entries
        const totalQty = matchingChallans.reduce((sum, challan) => {
          const challanDetails = JSON.parse(challan.dc_details || "[]");
          const productQty = challanDetails.reduce((productSum, dcDetail) => {
            if (dcDetail.product === detail.product) {
              return productSum + parseFloat(dcDetail.qty || 0);
            }
            return productSum;
          }, 0);
          return sum + productQty;
        }, 0);

        // Calculate bal_qty
        const balQty = parseFloat(detail.soqty || 0) - totalQty;

        // Calculate empty_cyl_avl
        const emptyCylCount = cylinder.filter(cyl => 
          cyl.cylinder_location === "Empty store" && 
          cyl.prod_code === detail.product
        ).length;

        return {
          ...detail,
          delivery_qty: totalQty, // Update delivery_qty with the calculated total
          bal_qty: balQty, // Calculate and update bal_qty
          empty_cyl_avl: emptyCylCount, // Set the count of available empty cylinders
        };
      });

      return {
        ...entry,
        schedule_details: updatedScheduleDetails,
      };
    });

    setPpDetails(updatedPpDetails);
  }
}, [schedule_entry, delivery_challan, cylinder]);


const handleChange = ({ target }) => {
    const value = target.value;
    setData({
      ...data,
      [target.name]: value,
    });
    data[target.name] = target.value;
  };

  // const [successMessage, setSuccessMessage] = useState(null);

  const onSubmit = (event) => {
    const pp_Data = {
      ...data,
      pp_id: editid,
      pp_details: JSON.stringify(pp_details),
      changedUpdatedValue: "edit",
    };
    if (editData) {
      dispatch(editDeleteProductionPlanning(pp_Data));
    } else {
      dispatch(addProductionPlanning(pp_Data));
    }
  };

  const [isUpdateArray, setIsUpdateArray] = useState(false);

  // const [pp_details, setPpDetails] = useState(
  //   editData
  //     ? JSON.parse(editData.pp_details)
  //     : [
  //         {
  //           sr_no: "",
  //           customer_name: "",
  //           schedule_no: "",
  //           // schedule_date: new Date(),
  //           product_code: "",
  //           product_description: "",
  //           cyl_code: "",
  //           schedule_quantity: "",
  //           uom: "",
  //           del_qty: "",
  //           bal_qty: "",
  //           empty_cyl_avl: "",
  //           plan_quantity: "",
  //           // unit: "",
  //         },
  //       ]
  // );

  const handleChangeInput = (e, i,index,detailIndex = null) => {
    const array = [...pp_details];
    let result = array[i];
    result[e.target.name] = e.target.value;
    result.srno = i + 1;
    array[i] = result;
    setPpDetails(array);
    setIsUpdateArray(!isUpdateArray );

    array[i] = result;

    // const reducer = (previousValue, currentValue) =>
    //   previousValue + currentValue;

    setIsSet(isSet ? false : true);
  };


  const handlechangeedit = (e, index, detailIndex = null) => {
    const { name, value } = e.target;
    const updatedPpDetails = [...pp_details];
  
    if (detailIndex !== null) {
      // Update child data
      updatedPpDetails[index].schedule_details[detailIndex][name] = value;
    } else {
      // Update main data
      updatedPpDetails[index][name] = value;
    }
  
    setPpDetails(updatedPpDetails);
  };

  const handleChangeApprovedCyl = (e, index, detailIndex = null) => {
    const { value } = e.target;
    const updatedPpDetails = [...pp_details];
  
    // Update the approved_cyl value in the respective detail
    updatedPpDetails[index].schedule_details[detailIndex].approved_cyl = value;
  
    setPpDetails(updatedPpDetails);
  };
  
  
  const handleRemoveScheduledetails = (index) => {
    const values = [...pp_details];
    values.splice(index, 1);
    setPpDetails(values);
    setIsUpdateArray(isUpdateArray ? false : true);
    const reducer = (previousValue, currentValue) =>
      previousValue + currentValue;
  };

  const handleAddPPFields = () => {
    setPpDetails([
      ...pp_details,
      {
        sr_no: pp_details.length + 1,
        customer_name: "",
        schedule_no: "",
        // schedule_date: new Date(),
        // product_code: "",
        // product_description: "",
        // cyl_code: "",
        // schedule_quantity: "",
        // uom: "",
        // del_qty: "",
        // bal_qty: "",
        // empty_cyl_avl: "",
        approved_cyl: "",
        // unit: "",
      },
    ]);
  };
  //let navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState(null);
  const respMsgState = useSelector(
    (state) => state.production_planning.message
  );
  const { shouldShowMsg, responseMessage } = useMessageHandler(
    null,
    navigate,
    setSuccessMessage,
    respMsgState
  );

  useEffect(() => {}, [shouldShowMsg, responseMessage]);

  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [isCylinderModalOpen, setIsCylinderModalOpen] = useState(false);

  // const handleOpenModal = () => {
  //   setIsModalOpen(true);
  // };

  const handleScheduleOpenModal = () => {
    setIsScheduleModalOpen(true);
  };
  const handleCylinderOpenModal = () => {
    setIsCylinderModalOpen(true);
  };

  // const handleCloseModal = () => {
  //   setIsModalOpen(false);
  // };
  const handleScheduleCloseModal = () => {
    setIsScheduleModalOpen(false);
  };
  const handleCylinderCloseModal = () => {
    setIsCylinderModalOpen(false);
  };

  return (
    <>
      <Paper className={`${styles.cts_page}`}>
        <Breadcrumb routeSegments={[{ name: "Production Planning" }]} />
        <Box style={{ height: "20px" }}></Box>
        <Box>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={1} sx={{ mt: 0 }}>
              <Grid
                item
                xs={4}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid container spacing={1} sx={{ mt: 0 }}>
                  {/* <Grid item xs={5} className={`${styles.grid_input}`}>
                    <Typography className={`${styles.cts_lable}`}>
                      Entry No
                    </Typography>
                    <CTSinput
                      size="small"
                      fullWidth
                      type="text"
                      onChange={handleChange}
                      name="pp_no"
                      value={data.pp_no}
                    />
                  </Grid> */}
                  <Grid container spacing={1} sx={{ mt: 0 }}>
                        {editData === null ? (                         
                          <Typography sx={{ fontSize: '14px', fontWeight: 'bold', color: 'blue' }}>
                            Last Entry No : {production_planning && production_planning.length > 0 ? production_planning[0].lastppEntryNo : 0}
                          </Typography>
                        ) : null}
                      </Grid>
                  <Grid item xs={2} className={`${styles.grid_label}`}>
                    <Typography className={`${styles.cts_lable}`}>Entry No</Typography>
                  </Grid>
                  <Grid item xs={4} className={`${styles.grid_input}`}>
                    <CTSinput
                      size="small"
                      fullWidth
                      value={data.pp_no}
                      variant="outlined"
                      InputProps={{
                        readOnly: true,
                        style: {
                          height: 30,
                          fontSize: 12,
                          backgroundColor: "#f0f0f0",
                        },
                      }}

                    />
                  </Grid>
                  <Grid item xs={6} className={`${styles.grid_input}`}>
                    <Typography className={`${styles.cts_lable}`}>
                      Date
                    </Typography>
                    <CTSinput
                      size="small"
                      fullWidth
                      type="date"
                      onChange={handleChange}
                      name="pp_date"
                      value={data.pp_date}
                    />
                  </Grid>
                  <Grid item xs={12} className={`${styles.grid_input}`}>
                    <Typography className={`${styles.cts_lable}`}>
                      Prepared By
                    </Typography>
                    <CTSinput
                      size="small"
                      fullWidth
                      type="text"
                      onChange={handleChange}
                      name="prepared_by"
                      value={data.prepared_by}
                    />
                  </Grid>
                  <Grid item xs={12} className={`${styles.grid_input}`}>
                    <Typography className={`${styles.cts_lable}`}>
                      Approved By
                    </Typography>
                    <CTSinput
                      size="small"
                      fullWidth
                      type="text"
                      onChange={handleChange}
                      name="approved_by"
                      value={data.approved_by}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Schedule Details Table Section */}
              <Grid item xs={12}>
                <TableContainer
                  style={{
                    maxHeight: "250px",
                    minHeight: "400px",
                    marginTop: "20px",
                  }}
                >
                 {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={handleScheduleOpenModal}
                    style={{ marginRight: "10px", marginBottom: "10px" }}
                  >
                    View Schedule
                  </Button> */}
                  <Modal
                    open={isScheduleModalOpen}
                    onClose={handleScheduleCloseModal}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "55%",
                        transform: "translate(-50%, -50%)",
                        width: "70%",
                        maxHeight: "80%",
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 4,
                        overflowY: "auto",
                      }}
                    >
                      <IconButton
                        aria-label="close"
                        onClick={handleScheduleCloseModal}
                        sx={{
                          position: "absolute",
                          right: 8,
                          top: 8,
                          color: (theme) => theme.palette.grey[500],
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                      <ViewScheduleList onSelectRecords={handleSelectRecords} />
                    </Box>
                  </Modal>

                  {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={handleCylinderOpenModal}
                    style={{ marginBottom: "10px" }}
                  >
                    Empty Cylinders
                  </Button> */}

                  <Modal
                    open={isCylinderModalOpen}
                    onClose={handleCylinderCloseModal}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "55%",
                        transform: "translate(-50%, -50%)",
                        width: "70%",
                        maxHeight: "80%",
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 4,
                        overflowY: "auto",
                      }}
                    >
                      <IconButton
                        aria-label="close"
                        onClick={handleCylinderCloseModal}
                        sx={{
                          position: "absolute",
                          right: 8,
                          top: 8,
                          color: (theme) => theme.palette.grey[500],
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                      <ViewCylinderList onSelectRecords={handleSelectRecords} />
                    </Box>
                  </Modal>
                  {/* <Modal open={isModalOpen} onClose={handleCloseModal}>
                    <div>
                      <ViewScheduleList onSelectRecords={handleSelectRecords} />
                    </div>
                  </Modal> */}
                  <Table
                    sx={{ minWidth: 750 }}
                    stickyHeader
                    size="small"
                    aria-label="a dense table"
                  >
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell
                          align="center"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "4px" }}
                          width="8%"
                        >
                          Sr No
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          Customer Name
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "4px" }}
                          width="8%"
                        >
                          Sch No
                        </StyledTableCell>

                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          Product Code
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          Product Description
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "4px" }}
                          width="8%"
                        >
                          Cyl Code
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          PO Quantity
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "4px" }}
                          width="8%"
                        >
                          UOM
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "4px" }}
                          width="8%"
                        >
                          Del Qty
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "4px" }}
                          width="8%"
                        >
                          Bal Qty
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "4px" }}
                          width="8%"
                        >
                          Empty Cyl Avl
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          Plan Quantity
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className={`${styles.table_head}`}
                        />
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {pp_details &&
                        pp_details.map((row, index) => (
                          <React.Fragment key={index}>
                            {row.schedule_details?.map((detail, detailIndex) => (
                              <StyledTableRow key={detailIndex}>
                                <StyledTableCell align="center">{index + 1}</StyledTableCell>
                                <StyledTableCell align="right">
                                  <CTSinput
                                    fullWidth
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                    }}
                                    size="small"
                                    type="text"
                                    name="customer_name"
                                    value={row.customer_name}
                                    // onChange={(e) => handleChangeInput(e, index)}
                                  />
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <CTSinput
                                    fullWidth
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                    }}
                                    size="small"
                                    type="text"
                                    name="schedule_no"
                                    value={row.schedule_no}
                                   // onChange={(e) => handleChangeInput(e, index)}
                                  />
                                </StyledTableCell>
                                <StyledTableCell align="right">
                                  <CTSinput
                                    fullWidth
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                    }}
                                    size="small"
                                    type="text"
                                    name="product"
                                    value={detail.product}
                                   // onChange={(e) => handleChangeInput(e, index, detailIndex)}
                                  />
                                </StyledTableCell>
                                <StyledTableCell align="right">
                                  <CTSinput
                                    fullWidth
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                    }}
                                    size="small"
                                    type="text"
                                    name="prod_description"
                                    value={detail.prod_description}
                                  //  onChange={(e) => handleChangeInput(e, index, detailIndex)}
                                  />
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <CTSinput
                                    fullWidth
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                    }}
                                    size="small"
                                    type="text"
                                    name="cylinder_code"
                                    value={detail.cylinder_code}
                                  //  onChange={(e) => handleChangeInput(e, index, detailIndex)}
                                  />
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <CTSinput
                                    fullWidth
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                    }}
                                    size="small"
                                    type="number"
                                    name="soqty"
                                    value={detail.soqty}
                                  //  onChange={(e) => handleChangeInput(e, index, detailIndex)}
                                  />
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <CTSinput
                                    fullWidth
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                    }}
                                    size="small"
                                    type="text"
                                    name="uom"
                                    value={detail.uom}
                                  //  onChange={(e) => handleChangeInput(e, index, detailIndex)}
                                  />
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <CTSinput
                                    fullWidth
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                    }}
                                    size="small"
                                    type="text"
                                    name="delivery_qty"
                                    value={detail.delivery_qty}
                                  //  onChange={(e) => handleChangeInput(e, index, detailIndex)}
                                  />
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <CTSinput
                                    fullWidth
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                    }}
                                    size="small"
                                    type="text"
                                    name="bal_qty"
                                    value={detail.bal_qty}
                                  //  onChange={(e) => handleChangeInput(e, index, detailIndex)}
                                  />
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <CTSinput
                                    fullWidth
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                    }}
                                    size="small"
                                    type="text"
                                    name="empty_cyl_avl"
                                    value={detail.empty_cyl_avl}
                                  //  onChange={(e) => handleChangeInput(e, index, detailIndex)}
                                  />
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <CTSinput
                                    fullWidth
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                    }}
                                    size="small"
                                    type="text"
                                    name="approved_cyl"
                                    value={detail.approved_cyl}
                                    onChange={(e) => handleChangeApprovedCyl(e, index, detailIndex)}
                                  />
                                </StyledTableCell>
                                
                                {/* Add more child fields as needed */}
                              </StyledTableRow>
                            ))}
                          </React.Fragment>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              {/* Save/Cancel Buttons Section */}
              <Grid item xs={8} md={8} />

              <Grid item xs={12} className={`${styles.grid_input}`}>
                <Box sx={{ marginTop: "12px", float: "right" }}>
                  <Button
                    color="primary"
                    id={`${styles.btn_save}`}
                    variant="contained"
                    type="submit"
                  >
                    <SaveIcon
                      style={{ fontSize: "16px", marginRight: "10px" }}
                    />{" "}
                    {editData ? "Update" : "Save"}
                  </Button>
                  <Cancel />
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Paper>
    </>
  );
};
export default ProductionPlanningAdd;
